import Layout from "../../components/Layout";
// import EmployeeSubject from "./employee/EmployeeSubject";
import EmployerSubject from "./employer/EmployerSubject";
import StudentSubject from "./student/Student";
import GuardianSUbject from "./guardian/Guardian";
import { useUserState } from "../../context/UserContext";

const Profile = () => {
  const { userRole } = useUserState();

  return (
    <Layout children={
      <>
        {userRole?.role_type === "school_admin" || userRole?.role_type
 === "employee" ? (
            <EmployerSubject />
          ) : userRole?.role_type === "guardian" ? <GuardianSUbject /> : <StudentSubject /> }
      </>
    }
    />
  );
};

export default Profile;
